import { connect } from 'react-redux'
import { actions, selectors } from '@opallabs/wormhole'
import AssetExport from '.'

const AssetExportComponent = (props) => <AssetExport {...props} />

const mapStateToProps = (state, props) => ({
  ...props,
  rowCount: state.assetCSVRowCount || 0,
  workspaceId: state.current_workspace_id,
  currentStory: selectors.selectCurrentStory(state),
})

const mapDispatchToProps = (dispatch) => ({
  getRowCount: (params) => {
    dispatch(actions.getAssetCSVRowCount(params))
  },
  createCSV: (params) => {
    dispatch(actions.createCSV(params))
  },
})

const ConnectedAssetExport = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetExportComponent)

export default ConnectedAssetExport
